import React, { Component } from "react";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Typography from "@material-ui/core/Typography";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withTranslation, Trans } from "react-i18next";

const styles = (theme) => ({
  formControl: {
    flex: 1,
    marginRight: 10,
    textAlign: "left",
  },
  filterIntro: {
    marginTop: 20,
    marginRight: 10,
  },
  container: {
    marginTop: 10,
  },
  tabBar: {
    marginBottom: 20,
  },
});

export class FilterBuilder extends Component {
  state = {
    onlyReadFilters: [
      {
        itemLocation: "",
        qualifier: "",
        text: "",
      },
    ],
    doNotReadFilters: [
      {
        itemLocation: "",
        qualifier: "",
        text: "",
      },
    ],
    doNotSpiderFilters: [
      {
        itemLocation: "",
        qualifier: "",
        text: "",
      },
    ],
    tab: 0,
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.filtersUpdated(prevState);
    }
  }

  render() {
    const { classes, t } = this.props;
    return (
      <div className={classes.container}>
        <Tabs
          value={this.state.tab}
          onChange={(e, val) => this.setState({ tab: val })}
          className={classes.tabBar}
          centered
        >
          <Tab label={t("create_ks_filter_only_read")} id="only-read-tab" />
          <Tab
            disabled={this.hasOnlyRead()}
            label={t("create_ks_filter_do_not_read")}
            id="do-not-read-tab"
          />
          <Tab
            label={t("create_ks_filter_do_not_spider")}
            id="do-not-spider-tab"
          />
        </Tabs>
        {this.state.tab === 0 && (
          <>
            <Typography variant="h6">
              <Trans i18nKey="create_ks_only_read_filters" />
            </Typography>
            <Typography variant="body2">
              <Trans i18nKey="create_ks_only_read_filters_subtitle" />
            </Typography>
            <Typography gutterBottom variant="body2">
              <Trans i18nKey="create_ks_only_read_filters_subtitle_mutually_exclusive" />
            </Typography>
            {this.state.onlyReadFilters.map((filter, idx) => {
              return this.getFilterBuilderElements(
                filter,
                idx,
                "onlyReadFilters"
              );
            })}
            {this.addNewFilterButton("onlyReadFilters")}
          </>
        )}
        {this.state.tab === 1 && (
          <>
            <Typography variant="h6">
              <Trans i18nKey="create_ks_do_not_read_filters" />
            </Typography>
            <Typography gutterBottom variant="body2">
              <Trans i18nKey="create_ks_do_not_read_filters_subtitle" />
            </Typography>
            {this.state.doNotReadFilters.map((filter, idx) => {
              return this.getFilterBuilderElements(
                filter,
                idx,
                "doNotReadFilters"
              );
            })}
            {this.addNewFilterButton("doNotReadFilters")}
          </>
        )}
        {this.state.tab === 2 && (
          <>
            <Typography variant="h6">
              <Trans i18nKey="create_ks_do_not_spider_filters" />
            </Typography>
            <Typography gutterBottom variant="body2">
              <Trans i18nKey="create_ks_do_not_spider_filters_subtitle" />
            </Typography>
            {this.state.doNotSpiderFilters.map((filter, idx) => {
              return this.getFilterBuilderElements(
                filter,
                idx,
                "doNotSpiderFilters"
              );
            })}
            {this.addNewFilterButton("doNotSpiderFilters")}
          </>
        )}
      </div>
    );
  }

  addNewFilterButton = (type) => {
    const { classes } = this.props;
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          variant="outlined"
          color="secondary"
          style={{ marginTop: 10 }}
          onClick={() => this.addNewFilter(type)}
          startIcon={<AddIcon />}
          id="new-filter-clause"
        >
          <Trans i18nKey="create_ks_new_filter" />
        </Button>
      </div>
    );
  };

  getFilterBuilderElements = (filter, idx, type) => {
    const { classes } = this.props;
    // the select is so horrible because you can't have fragments as children of menus so we have to use arrays
    return (
      <div style={{ textAlign: "center" }}>
        <div style={{ display: "flex" }} key={idx}>
          <Typography className={classes.filterIntro}>
            {this.getReadableType(type)} <Trans i18nKey="global_item_plural" />
          </Typography>
          <FormControl className={classes.formControl}>
            <InputLabel id="location-label">
              <Trans i18nKey="create_ks_filter_on_label" />
            </InputLabel>
            <Select
              labelId="location-label"
              id="location"
              value={filter.itemLocation}
              onChange={(e) =>
                this.updateFilter(idx, "itemLocation", e.target.value, type)
              }
            >
              {[
                this.props.isFiles && [
                  <MenuItem value="directory">
                    <Trans i18nKey="create_ks_filter_in_directories_with_name" />
                  </MenuItem>,
                  <MenuItem value="contenttype">
                    <Trans i18nKey="create_ks_filter_with_content_type" />
                  </MenuItem>,
                  <MenuItem value="name">
                    <Trans i18nKey="create_ks_filter_with_name" />
                  </MenuItem>,
                  [
                    this.props.sourceType === "GOOGLE_DRIVE" && [
                      <MenuItem value="shareddrives">
                        <Trans i18nKey="create_ks_filter_in_shared_drives_with_name" />
                      </MenuItem>,
                    ],
                  ],
                ],
                [
                  this.props.isUrls && [
                    <MenuItem value="url">
                      <Trans i18nKey="create_ks_filter_with_url" />
                    </MenuItem>,
                    [
                      type !== "doNotSpiderFilters" && [
                        <MenuItem value="contenttype">
                          <Trans i18nKey="create_ks_filter_with_content_type" />
                        </MenuItem>,
                      ],
                    ],
                  ],
                ],
              ]}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel id="qualifier-label">
              <Trans i18nKey="create_ks_filter_qualifier" />
            </InputLabel>
            <Select
              labelId="qualifier-label"
              id="qualifier"
              value={filter.qualifier}
              onChange={(e) =>
                this.updateFilter(idx, "qualifier", e.target.value, type)
              }
            >
              <MenuItem value="equalto">
                <Trans i18nKey="create_ks_filter_qualifier_exactly_equal_to" />
              </MenuItem>
              <MenuItem value="containing">
                <Trans i18nKey="create_ks_filter_qualifier_containing" />
              </MenuItem>
              <MenuItem value="beginningwith">
                <Trans i18nKey="create_ks_filter_qualifier_beginning_with" />
              </MenuItem>
              <MenuItem value="endingwith">
                <Trans i18nKey="create_ks_filter_qualifier_ending_with" />
              </MenuItem>
            </Select>
          </FormControl>
          <TextField
            label={this.props.t("create_ks_text_to_match_label")}
            style={{ flex: 2 }}
            id="text-to-match"
            value={filter.text}
            onChange={(e) =>
              this.updateFilter(idx, "text", e.target.value, type)
            }
          />
          <IconButton
            onClick={() => this.deleteFilter(idx, type)}
            id="delete-filter"
            style={{ marginTop: 10 }}
          >
            <DeleteIcon />
          </IconButton>
        </div>
        {idx !== this.state[type].length - 1 && (
          <Typography>
            <Trans i18nKey="global_and" />
          </Typography>
        )}
      </div>
    );
  };

  filtersUpdated = (prevState) => {
    if (this.state.onlyReadFilters !== prevState.onlyReadFilters) {
      this.constructOnlyReadRegex();
    }
    if (this.state.doNotReadFilters !== prevState.doNotReadFilters) {
      this.constructDoNotReadRegex();
    }
    if (this.state.doNotSpiderFilters !== prevState.doNotSpiderFilters) {
      this.constructDoNotSpiderRegex();
    }
  };

  constructDirectoryRegex = (filter) => {
    let regex = "";
    if (filter.qualifier === "equalto") {
      regex = `.*\/?${filter.text}\/.*$`;
    } else if (filter.qualifier === "containing") {
      regex = `.*\/?[^\/]*${filter.text}[^\/]*\/.*$`;
    } else if (filter.qualifier === "beginningwith") {
      regex = `.*\/?${filter.text}[^\/]*\/.*$`;
    } else if (filter.qualifier === "endingwith") {
      regex = `.*\/?[^\/]*${filter.text}\/.*$`;
    }
    return regex;
  };

  constructFilenameRegex = (filter) => {
    let regex = "";
    if (filter.qualifier === "equalto") {
      regex = `.*${filter.text}$`;
    } else if (filter.qualifier === "containing") {
      regex = `.*\/?[^\/]*${filter.text}[^\/]*$`;
    } else if (filter.qualifier === "beginningwith") {
      regex = `.*\/?${filter.text}[^\/]*$`;
    } else if (filter.qualifier === "endingwith") {
      regex = `.*\/?[^\/]*${filter.text}$`;
    }
    return regex;
  };

  constructContentTypeRegex = (filter) => {
    let regex = "";
    if (filter.qualifier === "equalto") {
      regex = `${filter.text.replace(/\//g, "\\/")}`;
    } else if (filter.qualifier === "containing") {
      regex = `.*${filter.text.replace(/\//g, "\\/")}.*`;
    } else if (filter.qualifier === "beginningwith") {
      regex = `${filter.text.replace(/\//g, "\\/")}.*`;
    } else if (filter.qualifier === "endingwith") {
      regex = `.*${filter.text.replace(/\//g, "\\/")}`;
    }
    return regex;
  };

  constructOnlyReadRegex = () => {
    let filters = [...this.state.onlyReadFilters];
    let regexes = {
      onlyReadFile: [],
      onlyReadContentType: [],
      onlyReadSharedDrives: [],
      onlyReadDocumentLibraries: [],
      onlyReadSites: [],
      onlyReadUrl: [],
    };
    filters.forEach((filter) => {
      if (filter.itemLocation === "directory") {
        let regex = this.constructDirectoryRegex(filter);
        regexes.onlyReadFile = regexes.onlyReadFile.concat(regex);
      } else if (filter.itemLocation === "name") {
        let regex = this.constructFilenameRegex(filter);
        regexes.onlyReadFile = regexes.onlyReadFile.concat(regex);
      } else if (
        filter.itemLocation === "contenttype" ||
        filter.itemLocation === "url" ||
        filter.itemLocation === "shareddrives"
      ) {
        let regex = this.constructContentTypeRegex(filter);
        if (filter.itemLocation === "contenttype") {
          regexes.onlyReadContentType = regexes.onlyReadContentType.concat(
            regex
          );
        } else if (filter.itemLocation === "url") {
          regexes.onlyReadUrl = regexes.onlyReadUrl.concat(regex);
        } else {
          regexes.onlyReadSharedDrives = regexes.onlyReadSharedDrives.concat(
            regex
          );
        }
      } else if (filter.itemLocation === "sites") {
        // TODO
      }
    });
    this.props.onOnlyReadUpdate(regexes);
  };

  constructDoNotReadRegex = () => {
    let filters = [...this.state.doNotReadFilters];
    let regexes = {
      doNotReadFile: [],
      doNotReadContentType: [],
      doNotReadSharedDrives: [],
      doNotReadDocumentLibraries: [],
      doNotReadSites: [],
      doNotReadUrl: [],
    };
    filters.forEach((filter) => {
      if (filter.itemLocation === "directory") {
        let regex = this.constructDirectoryRegex(filter);
        regexes.doNotReadFile = regexes.doNotReadFile.concat(regex);
      } else if (filter.itemLocation === "name") {
        let regex = this.constructFilenameRegex(filter);
        regexes.doNotReadFile = regexes.doNotReadFile.concat(regex);
      } else if (
        filter.itemLocation === "contenttype" ||
        filter.itemLocation === "url" ||
        filter.itemLocation === "shareddrives"
      ) {
        let regex = this.constructContentTypeRegex(filter);
        if (filter.itemLocation === "contenttype") {
          regexes.doNotReadContentType = regexes.doNotReadContentType.concat(
            regex
          );
        } else if (filter.itemLocation === "url") {
          regexes.doNotReadUrl = regexes.doNotReadUrl.concat(regex);
        } else {
          regexes.doNotReadSharedDrives = regexes.doNotReadSharedDrives.concat(
            regex
          );
        }
      } else if (filter.itemLocation === "sites") {
        // TODO
      }
    });
    this.props.onDoNotReadUpdate(regexes);
  };

  constructDoNotSpiderRegex = () => {
    let filters = [...this.state.doNotSpiderFilters];
    let regexes = {
      doNotSpiderFile: [],
      doNotSpiderContentType: [],
      doNotSpiderSharedDrives: [],
      doNotSpiderDocumentLibraries: [],
      doNotSpiderSites: [],
      doNotSpiderUrl: [],
    };
    filters.forEach((filter) => {
      if (filter.itemLocation === "directory") {
        let regex = this.constructDirectoryRegex(filter);
        regexes.doNotSpiderFile = regexes.doNotSpiderFile.concat(regex);
      } else if (filter.itemLocation === "name") {
        let regex = this.constructFilenameRegex(filter);
        regexes.doNotSpiderFile = regexes.doNotSpiderFile.concat(regex);
      } else if (
        filter.itemLocation === "contenttype" ||
        filter.itemLocation === "url" ||
        filter.itemLocation === "shareddrives"
      ) {
        let regex = this.constructContentTypeRegex(filter);
        if (filter.itemLocation === "contenttype") {
          regexes.doNotSpiderContentType = regexes.doNotSpiderContentType.concat(
            regex
          );
        } else if (filter.itemLocation === "url") {
          regexes.doNotSpiderUrl = regexes.doNotSpiderUrl.concat(regex);
        } else {
          regexes.doNotSpiderSharedDrives = regexes.doNotSpiderSharedDrives.concat(
            regex
          );
        }
      } else if (filter.itemLocation === "sites") {
        // TODO
      }
    });
    this.props.onDoNotSpiderUpdate(regexes);
  };

  getReadableType = (type) => {
    switch (type) {
      case "onlyReadFilters":
        return this.props.t("create_ks_filter_only_read");
      case "doNotReadFilters":
        return this.props.t("create_ks_filter_do_not_read");
      case "doNotSpiderFilters":
        return this.props.t("create_ks_filter_do_not_spider");
      default:
        return "";
    }
  };

  hasOnlyRead = () => {
    let has = false;
    this.state.onlyReadFilters.forEach((filter) => {
      if (filter.itemLocation && filter.qualifier && filter.text) {
        has = true;
      }
    });
    return has;
  };

  deleteFilter = (index, type) => {
    if (index === 0 && this.state[type].length === 1) {
      this.setState({
        [type]: [
          {
            itemLocation: "",
            qualifier: "",
            text: "",
          },
        ],
      });
    } else {
      let filters = [...this.state[type]];
      filters.splice(index, 1);
      this.setState({ [type]: filters });
    }
  };

  updateFilter = (index, field, value, type) => {
    let filters = [...this.state[type]];
    filters[index][field] = value;
    this.setState({ [type]: filters });
  };

  addNewFilter = (type) => {
    this.setState({
      [type]: [
        ...this.state[type],
        {
          itemLocation: "",
          qualifier: "",
          text: "",
        },
      ],
    });
  };
}

export default withStyles(styles)(withTranslation()(FilterBuilder));
